var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileDarkb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_256_personal_data_flatline",
    "data-name": "#256_personal_data_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.41,228.71c-1.93,17.31-7.35,40.41-9.84,49.06h25.32l15.53-1.88s3.6-33.75,5.86-41.14.51-77.9.58-78.61-38.05,16.6-41.85,33.08C130.54,195.64,137.06,222.87,136.41,228.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.57,278.27a.48.48,0,0,1-.4-.2.52.52,0,0,1-.08-.44c2.48-8.64,7.92-31.88,9.82-49h0c.28-2.52-.85-9.35-2-16.57-1.57-9.49-3.19-19.3-2.34-23,3.65-15.88,39.91-33.49,42.33-33.49h0a.53.53,0,0,1,.44.56c0,.15,0,2.06.08,4.7.31,16.74,1.25,67.67-.68,74-2.21,7.26-5.8,40.7-5.83,41a.5.5,0,0,1-.44.44L152,278.27Zm.66-1h24.66L167,275.44c.43-4,3.7-33.83,5.84-40.84,1.25-4.1,1.46-28.89.63-73.69,0-2.27-.06-3.49-.07-4.14-4.59,1.71-37.34,17.3-40.86,32.57-.8,3.47.88,13.62,2.36,22.57,1.2,7.3,2.34,14.2,2,16.85l-.49,0,.49,0C135,245.52,129.8,268.14,127.23,277.27Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.9 251.96 128.15 236.97 174.01 245.04 172.16 261.24 125.9 251.96",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.17,261.74h-.1l-46.27-9.28a.52.52,0,0,1-.4-.57l2.26-15a.5.5,0,0,1,.2-.33.51.51,0,0,1,.38-.09l45.85,8.08a.49.49,0,0,1,.41.54l-1.84,16.21a.51.51,0,0,1-.2.35A.52.52,0,0,1,172.17,261.74Zm-45.71-10.18,45.27,9.09,1.73-15.2-44.89-7.9Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.18 277.77 176.16 254.81 123.82 244.55 116.84 277.77 175.18 277.77",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,278.27H116.84a.5.5,0,0,1-.39-.18.53.53,0,0,1-.1-.42l7-33.22a.48.48,0,0,1,.58-.39l52.35,10.26a.48.48,0,0,1,.4.51l-1,23A.51.51,0,0,1,175.18,278.27Zm-57.72-1H174.7l1-22.06-51.44-10.08Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.64,
    y: 44.96,
    width: 143.56,
    height: 190.67,
    transform: "translate(-34.7 83.91) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,254.94a.5.5,0,0,1-.47-.33L119.88,75.46a.5.5,0,0,1,.3-.64L255.07,25.69a.5.5,0,0,1,.65.29L321,205.14a.5.5,0,0,1,0,.38.48.48,0,0,1-.28.26l-134.9,49.13A.47.47,0,0,1,185.6,254.94ZM121,75.58,185.9,253.8l134-48.79L255,26.8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.59,
    y: 44.21,
    width: 143.56,
    height: 190.67,
    transform: "translate(-34.69 82.47) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,254.18a.49.49,0,0,1-.47-.32L115.83,74.7a.49.49,0,0,1,.3-.64L251,24.93a.49.49,0,0,1,.64.3l65.25,179.15a.49.49,0,0,1-.3.64L181.72,254.15ZM116.94,74.83,181.85,253l134-48.79L250.89,26Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.39,
    y: 41.04,
    width: 143.56,
    height: 190.67,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -33.86, 80.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.35,251a.51.51,0,0,1-.47-.32L111.63,71.53a.5.5,0,0,1,.3-.64l134.9-49.13a.5.5,0,0,1,.38,0,.53.53,0,0,1,.26.29l65.25,179.15a.5.5,0,0,1-.3.64L177.52,251A.47.47,0,0,1,177.35,251ZM112.74,71.66l64.91,178.21,134-48.79L246.7,22.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.44,
    y: 71.66,
    width: 39.37,
    height: 47.54,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -22.81, 61.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.48,66.36,189.75,111l-37,13.47L136.49,79.83l37-13.47m0-1a1,1,0,0,0-.34.06l-37,13.47a1,1,0,0,0-.57.52,1,1,0,0,0,0,.77l16.27,44.67a1,1,0,0,0,.94.65,1,1,0,0,0,.34-.06l37-13.47a1,1,0,0,0,.6-1.28L174.42,66a1,1,0,0,0-.94-.66Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.91,
    y1: 67.53,
    x2: 218.48,
    y2: 57.49,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,68a.5.5,0,0,1-.18-1L218.3,57a.5.5,0,1,1,.35.94L191.08,68Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.72,
    y1: 78,
    x2: 234.15,
    y2: 63.63,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,78.5a.51.51,0,0,1-.47-.33.49.49,0,0,1,.3-.64L234,63.16a.5.5,0,0,1,.64.3.5.5,0,0,1-.29.64L194.89,78.47A.51.51,0,0,1,194.72,78.5Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.53,
    y1: 88.47,
    x2: 216.33,
    y2: 81.98,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,89a.52.52,0,0,1-.47-.33.5.5,0,0,1,.3-.64l17.8-6.49a.5.5,0,0,1,.64.3.49.49,0,0,1-.3.64l-17.8,6.49A.47.47,0,0,1,198.53,89Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.31,
    y1: 79.44,
    x2: 241.11,
    y2: 72.96,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.31,79.94a.49.49,0,0,1-.47-.33.5.5,0,0,1,.3-.64l17.8-6.48a.5.5,0,0,1,.34.94l-17.8,6.48A.51.51,0,0,1,223.31,79.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.35,99.44a.5.5,0,0,1-.18-1l27.57-10a.5.5,0,0,1,.64.3.49.49,0,0,1-.29.64l-27.57,10Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.52,132.13a.48.48,0,0,1-.47-.33.5.5,0,0,1,.3-.64l27.22-9.91a.5.5,0,0,1,.34.94l-27.22,9.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.3,
    y: 147.09,
    width: 13,
    height: 10.4,
    transform: "translate(-41.87 67.31) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.47,159.9a.52.52,0,0,1-.21,0,.55.55,0,0,1-.26-.28l-3.56-9.78a.5.5,0,0,1,.3-.64L174,144.71a.5.5,0,0,1,.38,0,.55.55,0,0,1,.26.28l3.56,9.77a.5.5,0,0,1-.3.64l-12.22,4.45A.47.47,0,0,1,165.47,159.9Zm-2.92-10,3.22,8.83,11.28-4.1-3.22-8.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.62,
    y: 129.59,
    width: 13,
    height: 10.4,
    transform: "translate(-36.28 63.96) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.79,142.4a.52.52,0,0,1-.47-.33l-3.56-9.77a.5.5,0,0,1,.3-.64l12.22-4.45a.5.5,0,0,1,.64.3l3.56,9.77a.5.5,0,0,1-.3.64L159,142.37A.47.47,0,0,1,158.79,142.4Zm-2.92-10,3.22,8.84,11.28-4.11-3.22-8.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49,148.54a.52.52,0,0,1-.47-.33.5.5,0,0,1,.3-.64l27.22-9.92a.5.5,0,0,1,.64.3.49.49,0,0,1-.3.64l-27.22,9.92A.47.47,0,0,1,181.49,148.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.39,
    y: 109.91,
    width: 13,
    height: 10.4,
    transform: "translate(-26.06 82.54) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,122.72a.5.5,0,0,1-.47-.33l-3.56-9.77a.46.46,0,0,1,0-.38.45.45,0,0,1,.28-.26L225,107.53a.5.5,0,0,1,.64.3l3.56,9.77a.49.49,0,0,1-.3.64l-12.21,4.45Zm-2.92-10,3.22,8.83,11.27-4.11-3.22-8.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58,111.35a.48.48,0,0,1-.47-.33.5.5,0,0,1,.3-.64l27.22-9.91a.5.5,0,0,1,.34.94l-27.22,9.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.36,
    y: 126.31,
    width: 13,
    height: 10.4,
    transform: "translate(-31.31 85.58) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.53,139.12a.5.5,0,0,1-.47-.33L218.5,129a.5.5,0,0,1,.3-.64L231,123.93a.51.51,0,0,1,.64.3l3.56,9.77a.5.5,0,0,1,0,.38.51.51,0,0,1-.28.26l-12.22,4.45A.47.47,0,0,1,222.53,139.12Zm-2.92-10,3.22,8.83,11.27-4.1L230.89,125Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.55,127.75a.49.49,0,0,1-.47-.33.51.51,0,0,1,.3-.64l27.22-9.91a.5.5,0,0,1,.34.94l-27.22,9.91A.47.47,0,0,1,238.55,127.75Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.65,
    y: 153.08,
    width: 108.64,
    height: 32.87,
    transform: "translate(-44.31 87.91) rotate(-20.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,204.05a.41.41,0,0,1-.21-.05.48.48,0,0,1-.26-.28l-11.25-30.88a.53.53,0,0,1,0-.39.49.49,0,0,1,.28-.25L272.21,135a.49.49,0,0,1,.64.3L284.1,166.2a.5.5,0,0,1,0,.38.45.45,0,0,1-.28.26L181.72,204A.47.47,0,0,1,181.55,204.05ZM170.94,173l10.91,29.95L283,166.07l-10.91-29.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.72,
    y1: 179.3,
    x2: 274.8,
    y2: 142.12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72,179.8a.5.5,0,0,1-.17-1l102.07-37.18a.5.5,0,1,1,.35.94L172.89,179.77Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.57,
    y1: 162.37,
    x2: 209.82,
    y2: 193.25,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.82,193.75a.5.5,0,0,1-.47-.32L198.1,162.54a.5.5,0,1,1,.94-.34l11.25,30.88a.5.5,0,0,1-.3.64A.34.34,0,0,1,209.82,193.75Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.43,209.27a.5.5,0,0,1-.17-1l41.18-15a.5.5,0,0,1,.34.94l-41.18,15Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05,213.65a.5.5,0,0,1-.17-1L287,175.5a.5.5,0,0,1,.35.94L185.22,213.62Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05,98.13l4.7,12.9-37,13.47-4.7-12.89c2.45-4.91,7.37-8.07,11.81-10.15,1.7-.8,3.34-1.43,4.74-1.94l.33-.12c1.3-.47,2.82-1,4.47-1.42l.09,0C174.23,96.69,180,96,185.05,98.13Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.51,100.39h0l.9,13.32.26,3.9-.83.3-2.31-3.16L160.68,104l0,0h0A24.76,24.76,0,0,1,170.51,100.39Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.39,86.4c-.56-2.89,3.74-5.22,4.69-1.91A5.1,5.1,0,0,1,171,88a3,3,0,0,1-2.79,1.82",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,90.3h-.2a.51.51,0,0,1-.47-.55.52.52,0,0,1,.55-.48,2.47,2.47,0,0,0,2.28-1.52,4.61,4.61,0,0,0,.08-3.11c-.38-1.32-1.27-1.31-1.77-1.2a2.61,2.61,0,0,0-1.92,2.88.5.5,0,0,1-.4.6.52.52,0,0,1-.61-.41,3.62,3.62,0,0,1,2.69-4.07,2.44,2.44,0,0,1,3,1.92,5.57,5.57,0,0,1-.13,3.82A3.54,3.54,0,0,1,168.34,90.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.07,90.53c-1.43-2.58-6.22-1.6-4.82,1.54a5.05,5.05,0,0,0,2.31,2.59,3,3,0,0,0,3.31-.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,95.5a3.77,3.77,0,0,1-1.63-.37,5.57,5.57,0,0,1-2.56-2.85,2.42,2.42,0,0,1,1.06-3.39,3.61,3.61,0,0,1,4.68,1.39.51.51,0,0,1-.9.5,2.6,2.6,0,0,0-3.32-1,1.39,1.39,0,0,0-.58,2,4.66,4.66,0,0,0,2.06,2.34,2.49,2.49,0,0,0,2.73-.31.52.52,0,0,1,.73,0,.51.51,0,0,1,0,.72A3.24,3.24,0,0,1,154,95.5Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,104a5.56,5.56,0,0,0,5.8.92,6.16,6.16,0,0,0,4.06-4.51L166.2,90.05l-8.9,3.24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,105.83a5.74,5.74,0,0,1-3.93-1.49.57.57,0,0,1-.13-.21l-3.35-10.69a.51.51,0,0,1,.32-.63L166,89.57a.52.52,0,0,1,.66.28L171,100.19a.65.65,0,0,1,0,.28,6.66,6.66,0,0,1-4.4,4.92A7,7,0,0,1,164.22,105.83Zm-3.11-2.14a5.05,5.05,0,0,0,5.16.73,5.68,5.68,0,0,0,3.7-4l-4.06-9.74-8,2.91Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,97.79a7.76,7.76,0,0,0,3.55,1.38c2.12.33,5.15.47,7.17-.64l-2-4.32A21.11,21.11,0,0,1,163,96a14.44,14.44,0,0,1-4.35.7C158.37,96.64,158.51,97.46,158.94,97.79Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4,99.9a20.08,20.08,0,0,1-3-.24,8.11,8.11,0,0,1-3.77-1.48,1.62,1.62,0,0,1-.58-1.62.59.59,0,0,1,.6-.4,13.77,13.77,0,0,0,4.19-.68,20.46,20.46,0,0,0,4.61-1.71.53.53,0,0,1,.39,0,.48.48,0,0,1,.29.27l2,4.31a.5.5,0,0,1-.21.65A9.58,9.58,0,0,1,165.4,99.9Zm-6.32-2.74a.7.7,0,0,0,.17.24h0a7.29,7.29,0,0,0,3.32,1.28c1.26.19,4.31.53,6.44-.38l-1.56-3.41a22,22,0,0,1-4.34,1.55A15.89,15.89,0,0,1,159.08,97.16Zm-.48,0h0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41,97l.73-.27a6.67,6.67,0,0,0,4-8.55l-3.62-9.93A10.15,10.15,0,0,0,151.24,83L154.85,93A6.68,6.68,0,0,0,163.41,97Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51,77.28a8.36,8.36,0,0,1,4,.93l3.62,9.93a6.67,6.67,0,0,1-4,8.55l-.73.27a6.82,6.82,0,0,1-2.29.4A6.68,6.68,0,0,1,154.85,93L151.24,83a9.3,9.3,0,0,1,5.66-5.1,10.42,10.42,0,0,1,3.61-.66m0-1a11.53,11.53,0,0,0-4,.72,10.31,10.31,0,0,0-6.28,5.74,1,1,0,0,0,0,.69l3.61,9.93a7.69,7.69,0,0,0,9.88,4.6l.73-.27a7.71,7.71,0,0,0,4.61-9.88l-3.62-9.92a1,1,0,0,0-.44-.54,9.45,9.45,0,0,0-4.53-1.07Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.57 107.64 165.4 106.95 166.62 105.03 168.78 105.72 167.57 107.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.41 113.72 171.67 117.62 170.84 117.92 168.53 114.76 166.8 107.39 166.8 107.39 166.74 107.14 166.7 106.98 167.81 106.58 167.88 106.73 168 106.95 168 106.96 171.41 113.72",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.37,123.34a.51.51,0,0,1-.46-.29l-5.06-10.43a.52.52,0,0,1,.93-.45l5.05,10.43a.51.51,0,0,1-.24.69A.54.54,0,0,1,157.37,123.34Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,113.22a.5.5,0,0,1-.5-.39l-2.84-11.24a.52.52,0,0,1,1-.25l2.84,11.24a.52.52,0,0,1-.38.63Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19,91.65c-.95-3.11-2.56-6.89-2.05-7.7s1.13,0,1.64-.92.08-1,.08-1a12,12,0,0,1,3.42-1.93c1.18-.2,4-.38,5.06-1.88,0,0,2.7,1.63,3.25,2.92s1.51,5,1.76,4.85.75-3.52.65-5a6.28,6.28,0,0,0-5.26-5.64s-.39-1.64-4.46-1.24-7.56,3.13-8.32,4.73a12.17,12.17,0,0,0-.38,7.2c.59,1.78,1.27,1.76,1.27,1.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19,92.16a.5.5,0,0,1-.39-.18l-3.24-3.79c-.37-.13-1-.59-1.47-2.07a12.71,12.71,0,0,1,.4-7.58c.85-1.79,4.45-4.6,8.74-5,3.43-.33,4.53.71,4.87,1.29a6.79,6.79,0,0,1,5.42,6.07c0,.8-.2,5.1-.91,5.51a.55.55,0,0,1-.47,0c-.36-.14-.5-.45-1.24-2.82-.28-.89-.57-1.81-.79-2.31a8.48,8.48,0,0,0-2.67-2.45c-1.17,1.16-3.23,1.45-4.51,1.63l-.57.09a9.65,9.65,0,0,0-2.83,1.56,1.88,1.88,0,0,1-.3,1.15,1.34,1.34,0,0,1-1.28.77c-.24,0-.28,0-.38.17-.2.46.65,2.94,1.22,4.58.31.9.63,1.82.89,2.7a.51.51,0,0,1-.24.6A.54.54,0,0,1,154.19,92.16Zm-3.27-5a.4.4,0,0,1,.32.18l1.63,1.91-.06-.17c-1.05-3.06-1.58-4.69-1.11-5.45a1.3,1.3,0,0,1,1.21-.66c.25,0,.29,0,.41-.24a1.76,1.76,0,0,0,.18-.42.59.59,0,0,1-.15-.27.55.55,0,0,1,.19-.51,12.24,12.24,0,0,1,3.65-2l.6-.09c1.24-.17,3.32-.47,4.13-1.58a.51.51,0,0,1,.68-.14c.3.17,2.86,1.75,3.46,3.15.23.55.53,1.5.82,2.41.11.34.23.72.35,1.08a20.22,20.22,0,0,0,.26-3.43,5.77,5.77,0,0,0-4.84-5.18.51.51,0,0,1-.41-.39h0s-.46-1.18-3.91-.84c-4,.39-7.27,3.1-7.9,4.45a11.62,11.62,0,0,0-.37,6.8c.43,1.28.85,1.42.85,1.42Zm2.81-4.72Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.47,51.47a2.86,2.86,0,0,1-2.68-1.88l-4.53-12.45a.49.49,0,0,1,.29-.64.52.52,0,0,1,.65.3l4.53,12.45A1.85,1.85,0,0,0,230.21,48l-6.57-18a3.47,3.47,0,0,0-4.43-2.07,3.45,3.45,0,0,0-2.07,4.44l.25.69a.5.5,0,0,1-.3.64.49.49,0,0,1-.64-.3l-.25-.69a4.46,4.46,0,0,1,6.07-5.57,4.44,4.44,0,0,1,2.31,2.52l6.57,18a2.87,2.87,0,0,1-2.68,3.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.35,197.61c5.47-9,12.52-22.83,17.11-32.27,2.25-4.63,10.54-2.06,11.14,1.87.83,5.5-8.85,33.82-8.91,33.75a30,30,0,0,1,3.22,32.95",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.91,234.42a.44.44,0,0,1-.24-.07.49.49,0,0,1-.19-.68,29.69,29.69,0,0,0-3.18-32.39.5.5,0,0,1-.08-.5l0-.07c.55-1.3,9.64-28.25,8.85-33.42-.27-1.76-2.52-3.45-5.14-3.85-2.34-.35-4.23.44-5.05,2.12-2.37,4.86-10.6,21.58-17.13,32.31a.5.5,0,0,1-.69.16.49.49,0,0,1-.17-.68c6.51-10.69,14.73-27.37,17.09-32.23,1-2.1,3.3-3.1,6.1-2.67,2.61.4,5.6,2.18,6,4.69.72,4.74-7,29.59-8.85,33.7a30.33,30.33,0,0,1,3.11,33.32A.51.51,0,0,1,160.91,234.42Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.74,
    cy: 248.04,
    r: 2.17,
    fill: "#231f20"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDarkb);
export default __webpack_public_path__ + "static/media/profile_darkb.34f6f0367fc01340a220a065967ce083.svg";
export { ForwardRef as ReactComponent };